import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m9g7q2h2bj: FaireBrandEntity = {
  token: "b_m9g7q2h2bj",
  type: "brand",
  name: "MKS America",
  avatarUrl:
    "https://cdn.faire.com/fastly/a050fb72a51177c272ec069646d9f468c6eac044df42c59079d8a3e932de3412.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e36b70e13fe273029e5c77075d2b0f634cc991455e159ae20a3cde5c616b9038.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a050fb72a51177c272ec069646d9f468c6eac044df42c59079d8a3e932de3412.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e36b70e13fe273029e5c77075d2b0f634cc991455e159ae20a3cde5c616b9038.jpeg",
  location: "Anaheim, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.7,
  reviewCount: 34,
  isInsider: true,
  description:
    "MKS America is based in the heart of the fashion industry in Los Angeles. The company was founded in 2017 with an ambition to inspire and provide influential fashion to the world. our brand is operated by professional design tea, sewing team and manufacture team. MKS America's highest goal is our customers' satisfaction with our high quality and well-designed accessories. We always try to provide high quality and the latest fashion accessories for our customer.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:11.257Z",
    importedBy: "entity-db-cli",
  },
};
